import script from "./Honor.vue?vue&type=script&setup=true&lang=js"
export * from "./Honor.vue?vue&type=script&setup=true&lang=js"

import "./Honor.vue?vue&type=style&index=0&id=af6c4178&lang=stylus&scoped=true"

import exportComponent from "/Users/wuhelong/Documents/文稿/project_two/华都官网/huadu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af6c4178"]])

export default __exports__